import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';
import { UserCommonService } from 'app/modules/shared/services/user-common.service';

@Component({
  selector: 'app-manage-shifts-team-list',
  templateUrl: './manage-shifts-team-list.component.html',
  styleUrls: ['./manage-shifts-team-list.component.scss']
})
export class ManageShiftsTeamListComponent implements OnInit {
  subject: Subject<any>;
  openShiftStatusColors = AppSettings.OPEN_SHIFT_STATUS;
  date = new Date();
  hideFilterSection: boolean;
  isLoaded = false;
  disableLoadMore = false;
  searchedTeam = '';
  sentSearchedTeam = '';
  providerId = '';
  currentPage = 'weekView';
  timezoneAbbr = '';
  offset = 0;
  availabilityList: any[] = [];
  selectedAvailability = '';
  teamOpenShiftStatusList: any[] = [];
  memberShiftAvailabilityList: any[] = [];
  teamShiftAvailabliltyDropdown: any[] = [];
  providerList: any[] = [];
  serviceRegionList: any[] = [];
  selectedServiceRegionIds: any[] = [];
  dayOffset = AppSettings.ONE_DAY_IN_MILISECOND;
  maxDate = new Date();
  minDate = this.date;
  currentDate = new Date();
  isSwitcher = false;
  path: string;
  userInfo: any;
  loginUserId: any;
  filterSavedFlag: Boolean = false;
  filterLocalData: any;
  FilterDataFlag: any;
  isDateChanged = false;
  disableProvider = false;

  constructor(private storageService: StorageService, private router: Router, private route: ActivatedRoute,
    private commonService: CommonBindingDataService,
    private manageOpenShiftsService: ManageOpenShiftsService,
    private uiService: UiService,
    private userCommonService: UserCommonService, ) {
    this.subject = new Subject();
  }

  ngOnInit(): void {
    this.path = this.route.snapshot.routeConfig.path;
    const futureMaxDateLimit = this.commonService.getTenantConfigValue(AppSettings.EDIT_TEAM_LIST_MAX_DATE);
    this.maxDate.setDate(this.maxDate.getDate() + parseInt(futureMaxDateLimit, 10));
    this.timezoneAbbr = this.commonService.getTenantConfigValue(AppSettings.TIMEZONE_ABBR);
    this.initializeDropdownValues();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPage = event.url.split('/')[2] === 'week' ? 'weekView' : 'dayView';
      }
    });
    this.subject.pipe(debounceTime(500)).subscribe(() => {
      this.sentSearchedTeam = this.searchedTeam;
    });

    this.userInfo = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.userInfo) {
      this.loginUserId = this.userInfo.id;
    }

    this.applyProviderRoleScope();
    this.loadServiceRegions();
    this.getProvider();

  }

  convertToCssClass(className: string) {
    const lowerCaseClass = className.split(' ').map((name) => name.toLowerCase());
    return lowerCaseClass.join('-');
  }

  getProvider() {
    // this.providerList.push({ label: this.commonBindingDataService.getLabel('All'), value: '' });
    this.manageOpenShiftsService.getProvider().subscribe(results => {
      const providerData = results;
      this.providerList.push({ label: this.commonService.getLabel('All'), value: '' });
      for (let i = 0; i < providerData.length; i++) {
        if (providerData[i].providerName !== null) {
          this.providerList.push({ label: providerData[i].providerName, value: providerData[i].id });
        }
      }
      this.getFilter();
      const filterObj: any = this.storageService.getItem(AppSettings.FILTER_DETAILS_TEAM);
      this.filterLocalData = filterObj;
      const savedFilterLocal = localStorage.getItem('teamFilterPresent');
      const localData = JSON.parse(savedFilterLocal);
      if (localData) {
        this.filterLocalData = localData.filterData;
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }


  initializeDropdownValues() {
    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA);
    if (tagsData) {
      this.setDropdownValues(tagsData);
      localStorage.removeItem('localTagdata');
      return;
    }

    const localTagData = localStorage.getItem('localTagdata');
    if (localTagData) {
      try {
        const parsedTagData = JSON.parse(localTagData);
        if (parsedTagData) {
          this.setDropdownValues(parsedTagData);
          return;
        }
      } catch (error) {
        localStorage.removeItem('localTagdata');
      }
    }

    this.userCommonService.getTagsListApi().subscribe((result) => {
      if (result) {
        this.storageService.setItem(AppSettings.TAG_DATA, result);
        localStorage.setItem('localTagdata', JSON.stringify(result));
        this.setDropdownValues(result);
      }
    });
  }

  setDropdownValues(tagsData) {
    if (!tagsData) {
      return;
    }

    (tagsData.teams_open_shift_status || []).forEach(element => {
      this.teamOpenShiftStatusList.push({ label: element.tagValue, value: this.convertToCssClass(element.tagValue) });
    });
    (tagsData.teams_member_availability || []).forEach(element => {
      this.memberShiftAvailabilityList.push({ label: element.tagValue, value: this.convertToCssClass(element.tagValue) });
    });
    this.teamShiftAvailabliltyDropdown.push({ label: this.commonService.getLabel('All'), value: '' });
    (tagsData.shift_availability || []).forEach(element => {
      this.teamShiftAvailabliltyDropdown.push({ label: element.tagValue, value: element.tagId });
    });
    if (this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PTO)?.value) {
      (tagsData.leave_type || []).forEach(element => {
        this.teamShiftAvailabliltyDropdown.push({ label: element.tagValue, value: element.tagId });
      });
    } else {
      this.teamShiftAvailabliltyDropdown.pop();
    }
    // tagsData.leave_type.forEach(element => {
    //   this.teamShiftAvailabliltyDropdown.push({ label: element.tagValue, value: element.tagId });
    // });
  }

  hideFilter(event) {
    this.hideFilterSection = event === true ? true : false;
  }

  loadMore() {
    this.offset += 10;
  }

  goToToday() {
    if (this.minDate.getTime() !== this.date.getTime()) {
      this.date = new Date();
      this.minDate = this.date;
    }
  }

  getTotalCount(totalCount: any) {
    this.disableLoadMore = ((this.offset + 10) > totalCount) ? true : false;
  }

  goToNextWeek() {
    if (this.currentPage === 'weekView') {
      if (this.maxDate.getTime() > this.date.getTime()) {
        const date = new Date();
        date.setTime(this.date.getTime() + (7 * this.dayOffset));
        this.date = date;
        this.offset = 0;
      }
    } else {
      if (this.maxDate.getTime() > this.date.getTime()) {
        const date = new Date();
        date.setTime(this.date.getTime() + (1 * this.dayOffset));
        this.date = date;
        this.offset = 0;
      }
    }
  }

  goToPreviousWeek() {
    if (this.currentPage === 'weekView') {
      // if (this.minDate.getTime() !== this.date.getTime()) {
      const date = new Date();
      date.setTime(this.date.getTime() - (7 * this.dayOffset));
      this.date = date;
      this.offset = 0;
      // }
    } else {
      // if (this.minDate.getTime() !== this.date.getTime()) {
      const date = new Date();
      date.setTime(this.date.getTime() - (1 * this.dayOffset));
      this.date = date;
      this.offset = 0;
      // }
    }
  }

  onResetFilter() {
    if (this.filterSavedFlag) {
      this.manageOpenShiftsService.resetFilter(this.loginUserId, 'TEAM_FILTER').subscribe(results => {
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
        this.filterSavedFlag = false;
        localStorage.removeItem('teamFilterPresent');
        this.storageService.removeItem(AppSettings.FILTER_DETAILS_TEAM);
      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
      });
    }
    this.offset = 0;
    this.date = new Date();
    this.minDate = this.date;
    this.searchedTeam = '';
    this.sentSearchedTeam = '';
    this.selectedAvailability = '';
    if (!this.disableProvider) {
      this.providerId = '';
    } else {
      this.providerId = this.loginUserId;
    }
    this.selectedServiceRegionIds = [];
    this.isDateChanged = false;
    this.loadServiceRegions();
  }

  loadServiceRegions(savedRegionIds?: any[], refresh = false) {
    const regions$ = this.providerId
      ? this.commonService.getServiceRegionsByProviderID(this.providerId)
      : this.commonService.getServiceRegions();

    regions$.subscribe((regions) => {
      this.serviceRegionList = this.commonService.mapServiceRegionOptions(regions);
      if (savedRegionIds && savedRegionIds.length) {
        this.selectedServiceRegionIds = savedRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      } else if (this.selectedServiceRegionIds.length) {
        this.selectedServiceRegionIds = this.selectedServiceRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      }
      if (refresh) {
        this.filterChangeTeam();
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  onProviderChange() {
    this.loadServiceRegions(undefined, true);
  }

  changeFilter() {
    this.offset = 0;
    this.isDateChanged = true;
  }

  searchTeam() {
    this.subject.next();
    this.offset = 0;
  }

  updateOffset(offset: any) {
    this.offset = offset;
  }

  changeTab() {
    this.isSwitcher = !this.isSwitcher;
    const isTab = this.isSwitcher ? 'day' : 'week';
    this.router.navigate(['/manage-shift', isTab]);
  }

  saveFilter() {
    const filterObj = {
      'date': new Date(this?.date)?.getTime(),
      'selectedAvailability': this.selectedAvailability,
      'providerId': this.providerId,
      'serviceRegionIds': this.selectedServiceRegionIds
    };
    const filterModel: any = {
      'userId': this.loginUserId,
      'filterType': 'TEAM_FILTER',
      'filterData': filterObj
    };

    this.manageOpenShiftsService.teamMemberSaveFilter(filterModel).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.filterSavedFlag = true;
      localStorage.setItem('teamFilterPresent', JSON.stringify(filterModel));
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getFilter() {
    console.log('no');
    const type = 'TEAM_FILTER';
    this.manageOpenShiftsService.teamGetFilter(this.loginUserId, type).subscribe(results => {
      this.FilterDataFlag = results.filterData;
      if (results.filterData !== null && results.filterData !== undefined) {
        const filterDataResults = JSON.parse(results.filterData);
        this.filterSavedFlag = true;
        if (filterDataResults?.selectedAvailability) {
          this.selectedAvailability = filterDataResults?.selectedAvailability;
        }
        if (filterDataResults?.providerId && !this.disableProvider) {
          this.providerId = filterDataResults?.providerId;
        }
        if (filterDataResults?.date !== 0 && filterDataResults?.date !== null) {
          this.date = new Date(filterDataResults?.date);
        }
        if (filterDataResults?.serviceRegionIds) {
          this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
        }
        this.ensureProviderIdForRole();
        this.loadServiceRegions(filterDataResults?.serviceRegionIds, true);
        this.getFilterLocal(filterDataResults);
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getFilterLocal(results) {
    if (results !== null && results !== undefined) {
      const filterDataResults = results;
      this.filterSavedFlag = true;
      if (filterDataResults?.selectedAvailability) {
        this.selectedAvailability = filterDataResults?.selectedAvailability;
      }
      if (filterDataResults?.providerId && !this.disableProvider) {
        this.providerId = filterDataResults?.providerId;
      }
      this.ensureProviderIdForRole();
      if (filterDataResults?.serviceRegionIds) {
        this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
      }
      if (filterDataResults?.date !== 0 && filterDataResults?.date !== null) {
        this.date = new Date(filterDataResults?.date);
      }
      if (filterDataResults.date > this.currentDate || this.currentDate > filterDataResults.date) {
        this.isDateChanged = true;
      } else {
        this.isDateChanged = false;
      }
    }
  }

  filterChangeTeam() {
    this.offset = 0;
    console.log('yes');
  }

  private applyProviderRoleScope() {
    const roleId = this.storageService.getItem<number>(AppSettings.USER_ROLE_ID);
    if (roleId === AppSettings.PROVIDER_ROLE_ID || roleId === 11) {
      this.disableProvider = true;
      this.providerId = this.loginUserId;
    }
  }

  private ensureProviderIdForRole() {
    if (this.disableProvider && this.loginUserId) {
      this.providerId = this.loginUserId;
    }
  }
}
